"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "framura": {
    "9aef7ceb": [{
      "hkey": "92793b33",
      "slug": "anzo-setta",
      "name": "Anzo-Setta",
      "primary": true,
      "skipSearch": false
    }],
    "anzo": [{
      "hkey": "92793b33",
      "slug": "anzo-setta",
      "name": "Anzo-Setta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "72b8039f": [{
      "hkey": "52e3ec93",
      "slug": "castagnola-cadelazzino",
      "name": "Castagnola-Cadelazzino",
      "primary": true,
      "skipSearch": false
    }],
    "castagnola": [{
      "hkey": "52e3ec93",
      "slug": "castagnola-cadelazzino",
      "name": "Castagnola-Cadelazzino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b75ca2b6": [{
      "hkey": "92793b33",
      "slug": "anzo-setta",
      "name": "Anzo-Setta",
      "primary": true,
      "skipSearch": false
    }],
    "ravecca": [{
      "hkey": "92793b33",
      "slug": "anzo-setta",
      "name": "Anzo-Setta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "framura"
    }],
    "02db1523": [{
      "hkey": "92793b33",
      "slug": "anzo-setta",
      "name": "Anzo-Setta",
      "primary": true,
      "skipSearch": false
    }],
    "setta": [{
      "hkey": "92793b33",
      "slug": "anzo-setta",
      "name": "Anzo-Setta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "framura"
    }]
  }
};
exports["default"] = _default;